import Axios from "axios";
import {
  antdMessageError,
  antdMessageInfo,
  antdMessageSuccess,
  buildErrorObject,
  errorHandler,
  exportDocument,
} from "../../helpers/Utils";

export const getAutosys = (page, filterParams) => async (dispatch) => {
  try {
    console.time();
    dispatch({ type: "LOADING_CUSTOM" });
    const { data } = await Axios.get(
      `/api/v1/autosys.json?page=${page}${filterParams}`
    );
    console.timeEnd();
    console.log({ data });
    dispatch({
      type: "GET_CUSTOMS",
      payload: { ...data, current: "Autosys" },
    });
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdMessageError();
    return { success: false };
  }
};

export const getAutosysItem = (id) => async (dispatch) => {
  try {
    const { data } = await Axios.get(`/api/v1/autosys/${id}`);
    if (!data.success) throw new Error("ERR");
    if (data.data?.api_error) antdMessageError(data.data.api_error);
    dispatch({
      type: "UPDATE_CUSTOM",
      payload: data.data,
    });
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdMessageError();
    return { success: false };
  }
};

export const putAutosys = (params) => async (dispatch) => {
  try {
    antdMessageInfo();
    const autosys = { ...params };
    autosys.autosys_products_attributes = params.autosys_products;
    delete autosys.autosys_products;
    delete autosys.full_name;

    const updating = params.id;

    const errorHandler = () => {
      let errors = {};
      if (!autosys.rule_title) errors.rule_title = "Cannot be empty";
      if (!autosys.auto_type) errors.auto_type = "Cannot be empty";
      if (!autosys.order_shop_ids || autosys.order_shop_ids.length == 0) errors.order_shop_ids = "Cannot be empty";
      if (!autosys.period || !autosys.period[0])
        errors.period = "Cannot be empty";
      return errors;
    };

    const errors = errorHandler();
    if (Object.keys(errors).length > 0) {
      antdMessageError("Valdidation errors");
      return { success: false, errors };
    }
    const { data } = await Axios({
      url: `/api/v1/autosys/${updating ? updating : ""}`,
      data: { autosys },
      method: updating ? "PUT" : "POST",
    });
    console.log({ data });
    if (!data.success) throw new Error("ERR");
    antdMessageSuccess();
    dispatch({
      type: updating ? "UPDATE_CUSTOM" : "POST_CUSTOM",
      payload: data.data,
    });
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdMessageError();
    return {
      success: false,
      errors: buildErrorObject(err?.response?.data?.errors),
    };
  }
};

export const duplicateAutosys = (id) => async (dispatch) => {
  try {
    const { data } = await Axios.post(
      `/api/v1/autosys/${id}/autosys_duplicate`
    );
    console.log({ data });
    if (!data.success) throw new Error("ERR");
    antdMessageSuccess();
    dispatch({
      type: "POST_CUSTOM",
      payload: data.data,
    });
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdMessageError();
    return { success: false };
  }
};

export const removeAutosys = (id) => async (dispatch) => {
  try {
    const { data } = await Axios.delete(`/api/v1/autosys/${id}`);
    console.log({ data });
    if (!data.success) throw new Error("ERR");
    antdMessageSuccess();
    dispatch({
      type: "REMOVE_CUSTOM",
      payload: id,
    });
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdMessageError();
    return { success: false };
  }
};

//
export const getAutosysOptions = () => async (dispatch) => {
  try {
    const getBrands = () =>
      Axios.get(`/api/v1/order_shops`).then((res) => {
        return res.data.shops;
      });

    Promise.all([getBrands()]).then((res) => {
      console.log("Response: ", { res });
      dispatch({
        type: "SET_OPTIONS",
        payload: {
          shops: res[0],
          // families: res[1],
        },
      });
    });
    return { success: true };
  } catch (err) {
    console.log("ERROR ", err);
    return { success: false };
  }
};
